import React from 'react';

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

export function formatarNumero(valor: any, decimais = 2) {
    if (valor === null || valor === undefined || valor === '') return '-';
    const numero = Number(valor);
    if (isNaN(numero)) return '-';
    return numero.toLocaleString('pt-BR', { minimumFractionDigits: decimais, maximumFractionDigits: decimais });
}

export function formatarData(valor: any) {
    if (!valor) return '-';
    const partes = String(valor).substring(0, 10).split('-');
    if (partes.length !== 3) return String(valor);
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
}

export function nomeMes(mes: number) {
    return MESES[mes - 1] || '';
}

const STATUS_LABEL: any = {
    normal: 'Dentro do esperado',
    abaixo: 'Abaixo do esperado',
    acima: 'Acima do esperado',
    sem_dados: 'Sem estimativa',
};

export default function UsinaResumoCards({ metricas, acumulado, referencia }: any) {
    if (!metricas) return null;

    const statusClasse = metricas.performance !== null ? `is-${metricas.status}` : '';
    const periodo = referencia ? `${nomeMes(referencia.mes)}/${referencia.ano}` : '';

    return (
        <div className="usina-cards">
            <div className="usina-card">
                <div className="usina-card-label">Geração no mês</div>
                <div className="usina-card-valor">{formatarNumero(metricas.gerado)} kWh</div>
                <div className="usina-card-nota">{periodo}</div>
            </div>

            <div className="usina-card">
                <div className="usina-card-label">Estimado no mês</div>
                <div className="usina-card-valor">{formatarNumero(metricas.estimado)} kWh</div>
                <div className="usina-card-nota">
                    {metricas.estimado_mensal > 0 ? `${formatarNumero(metricas.estimado_mensal)} kWh/mês contratado` : 'Sem projeto vinculado'}
                </div>
            </div>

            <div className={`usina-card ${statusClasse}`}>
                <div className="usina-card-label">Performance</div>
                <div className="usina-card-valor">
                    {metricas.performance !== null ? `${formatarNumero(metricas.performance, 1)} %` : '-'}
                </div>
                <div className="usina-card-nota">{STATUS_LABEL[metricas.status] || ''}</div>
            </div>

            <div className="usina-card">
                <div className="usina-card-label">Média diária</div>
                <div className="usina-card-valor">{formatarNumero(metricas.media_diaria)} kWh</div>
                <div className="usina-card-nota">
                    {metricas.dias_com_dados} de {metricas.dias_periodo} dias com dados
                </div>
            </div>

            <div className="usina-card">
                <div className="usina-card-label">Melhor dia</div>
                <div className="usina-card-valor">
                    {metricas.melhor_dia ? `${formatarNumero(metricas.melhor_dia.geracao)} kWh` : '-'}
                </div>
                <div className="usina-card-nota">
                    {metricas.melhor_dia ? formatarData(metricas.melhor_dia.data) : 'sem registros no período'}
                </div>
            </div>

            <div className="usina-card">
                <div className="usina-card-label">Horas de sol</div>
                <div className="usina-card-valor">{formatarNumero(metricas.horas_sol_media)} h</div>
                <div className="usina-card-nota">média no período</div>
            </div>

            <div className="usina-card">
                <div className="usina-card-label">Injetado</div>
                <div className="usina-card-valor">{formatarNumero(metricas.injetado)} kWh</div>
                <div className="usina-card-nota">autoconsumo {formatarNumero(metricas.autoconsumo)} kWh</div>
            </div>

            <div className="usina-card">
                <div className="usina-card-label">Acumulado</div>
                <div className="usina-card-valor">{formatarNumero(acumulado?.gerado)} kWh</div>
                <div className="usina-card-nota">{acumulado?.dias || 0} dias registrados</div>
            </div>
        </div>
    );
}
